import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

//Actions
import { getOrganization } from "../../../../../actions/content_actions";
import {
    addPreRegistrationSurvey,
    getPreRegistrationSurvey,
} from "../../../../../actions/survey_actions";

//Assets
import CCCEEarthDayPreRegTitleImage from "../static/images/2022-3ce-earthday-prereg-title.png";
import CCCEEarthDayLandscape from "../static/images/2022-3ce-earthday-prereg-landscape.png";
import CCCEEarthDayCloudsSky from "../static/images/2022-3ce-earthday-prereg-cloudssky-double.png";
import CCCEEarthDayBottomLandscape from "../static/images/2022-3ce-earthday-prereg-bottom-landscape.png";

//Styles
import {
    createTheme,
    Grid,
    ThemeProvider,
    StyledEngineProvider,
    adaptV4Theme,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";

//Components
import {
    StyledBlackButton,
    StyledBlackActionButton,
} from "../../../../default/Styled Components/Buttons";
import TypeWriter from "../../../../default/Styled Components/TypeWriter";

const pageWidth = 900;

const useStyles = makeStyles((theme) => ({
    root: {
        //minHeight: '100vh',
        flex: 1,
        msFlex: "1 1 auto",
    },
    main: {
        msFlex: "1 1 auto",
        maxWidth: "100%",
        backgroundImage: `url("${CCCEEarthDayCloudsSky}")`,
        backgroundSize: "cover",
        backgroundPosition: "bottom",
        marginBottom: -1,
        [theme.breakpoints.up(850)]: {
            backgroundImage: `url("${CCCEEarthDayLandscape}")`,
        },
    },
    footer: {
        backgroundColor: "#b2d240",
        textAlign: "center",
        minHeight: 133,
        padding: 10,
    },
    footerGridContainer: {
        maxWidth: 600,
        [theme.breakpoints.up(850)]: {
            margin: "0 auto",
        },
    },
    titleBox: {
        maxWidth: pageWidth,
        margin: "0 auto",
        marginTop: 40,
        backgroundColor: "rgba(255, 255, 255, 0.7)",
    },
    cardBox: {
        padding: 15,
        float: "right",
        width: 300,
        marginTop: 40,
        backgroundColor: "rgba(255, 255, 255, 0.7)",
    },
    earthDayTitleImage: {
        maxWidth: "100%",
    },
    blueGridItem: {
        backgroundColor: "#6DCFF6",
        minWidth: "100%",
        [theme.breakpoints.up(850)]: {
            display: "none",
        },
    },
    bottomLandscapeGridItem: {
        minWidth: "100%",
        [theme.breakpoints.up(850)]: {
            display: "none",
        },
    },
    bottomLandscapeImage: {
        width: "100%",
        display: "block",
    },
    giftCardImage: {
        maxWidth: "100%",
    },
    titleLine1: {
        fontWeight: 600,
        textAlign: "left",
        [theme.breakpoints.down("md")]: {
            fontSize: "1rem",
        },
    },
    titleLine2: {
        fontWeight: 600,
        textAlign: "center",
        [theme.breakpoints.down("md")]: {
            fontSize: "4rem",
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: "3rem",
        },
    },
    titleLine3: {
        fontWeight: 600,
        textAlign: "right",
        [theme.breakpoints.down("md")]: {
            fontSize: "4rem",
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: "3rem",
        },
    },
    titleLine4: {
        fontWeight: 600,
        textAlign: "right",
        [theme.breakpoints.down("md")]: {
            fontSize: "1rem",
        },
    },
    pulse: {
        animation: `$pulse 1.5s ${theme.transitions.easing.easeInOut} infinite`,
    },
    "@keyframes pulse": {
        "25%": {
            transform: "scale(0.9)",
        },
        "75%": {
            transform: "scale(1.1)",
        },
    },
    largeButton: {
        marginBottom: 10,
        [theme.breakpoints.down("md")]: {
            display: "none",
        },
    },
    smallButton: {
        marginBottom: 15,
        [theme.breakpoints.up("md")]: {
            display: "none",
        },
    },
    bounce: {
        animation: `$bounce 3s ${theme.transitions.easing.easeInOut} infinite`,
    },
    "@keyframes bounce": {
        "0%, 33%, 7%, 17%, 27%": {
            webkitTransform: "translateY(0)",
            msTransform: "translateY(0)",
            transform: "translateY(0)",
        },
        "13%": {
            webkitTransform: "translateY(-30px)",
            msTransform: "translateY(-30px)",
            transform: "translateY(-30px)",
        },
        "20%": {
            webkitTransform: "translateY(-15px)",
            msTransform: "translateY(-15px)",
            transform: "translateY(-15px)",
        },
    },
}));

function CampaignPage_2022_3ce_earthday(props) {
    const classes = useStyles();
    const { history, location } = props;

    const campaignKey = props.match.params.campaign_key;

    const handleClick = () => {
        history.push(
            `/${campaignKey}/task/G8M0JNt3Anamj1D9zSaG/${location.search}`
        );
    };

    //Thought I needed to change the theme but didn't, keeping this just in case
    const customTheme = createTheme(
        adaptV4Theme({
            typography: {
                fontFamily: "'Helvetica', 'Roboto', 'serif'",
            },
            palette: {
                primary: {
                    main: "#000000",
                },
                secondary: {
                    main: "#11cb5f",
                },
                info: {
                    main: "#ffffff",
                },
            },
        })
    );

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={customTheme}>
                <Grid container direction="column" className={classes.root}>
                    <Grid item xs className={classes.main}>
                        <div className={classes.titleBox}>
                            <div style={{ padding: 20 }}>
                                <img
                                    src={CCCEEarthDayPreRegTitleImage}
                                    className={classes.earthDayTitleImage}
                                    alt="earth-day-title"
                                />
                            </div>
                        </div>
                    </Grid>

                    <Grid item xs className={classes.blueGridItem}></Grid>

                    <Grid item className={classes.bottomLandscapeGridItem}>
                        <img
                            src={CCCEEarthDayBottomLandscape}
                            className={classes.bottomLandscapeImage}
                            alt="bottom-landscape"
                        />
                    </Grid>

                    <Grid item className={classes.footer}>
                        <StyledBlackActionButton
                            className={clsx(
                                classes.bounce,
                                classes.largeButton
                            )}
                            onClick={handleClick}
                            variant="contained"
                            color="primary"
                        >
                            JOIN THE VIRTUAL EVENT
                        </StyledBlackActionButton>
                        <StyledBlackButton
                            className={clsx(
                                classes.bounce,
                                classes.smallButton
                            )}
                            onClick={handleClick}
                            variant="contained"
                            color="primary"
                        >
                            JOIN THE VIRTUAL EVENT
                        </StyledBlackButton>
                        <TypeWriter
                            italicize={true}
                            textToBeTyped={[
                                "TO LEARN ABOUT ELECTRIC CARS",
                                "TO BECOME A HERO FOR OUR PLANET",
                                "TO WIN ELECTRIFYING PRIZES!",
                                "TO CREATE A FOSSIL FUEL FREE COMMUNITY",
                            ]}
                        />
                    </Grid>
                </Grid>
            </ThemeProvider>
        </StyledEngineProvider>
    );
}

const mapStateToProps = (state) => {
    return {
        organization: state.content.organization,
        preRegistrationSurvey: state.survey.preRegistrationSurvey,
    };
};

const mapDispatchToProps = {
    getOrganization,
    addPreRegistrationSurvey,
    getPreRegistrationSurvey,
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(CampaignPage_2022_3ce_earthday)
);
